import React, { useCallback } from "react"
import styled from "styled-components"
import { getCssSizeValue } from "@/utils/utils"
import Text from "@/components/common/Text"
import { ICONS, NAVIGATOR_VIEW_TYPE } from "@/constants"
import { useNavigatorContext } from "@/components/BranchNavigator"
import SimpleIconButton from "@/components/common/SimpleIconButton"
import { BREAKPOINTS } from "@/styles/themeSettings"
import useGlobals from "@/hooks/useGlobals"

const Wrapper = styled.div`
	animation: fade-in 0.35s ease-in-out;
	display: flex;
	flex-direction: column;
	row-gap: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	position: relative;
	width: 100%;
	min-height: ${getCssSizeValue(215, BREAKPOINTS.MOBILE)};
	border: 1px solid black;
	padding: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)} ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
	transition: background-color var(--rgr-duration) var(--ease);
	cursor: pointer;

	&.active,
	&:hover {
		background-color: ${({ theme }) => theme.colors.periwinkle};
	}

	.name {
		max-width: 90%;
	}

	*::selection {
		background-color: ${({ theme }) => theme.colors.white};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		min-height: ${getCssSizeValue(353)};
		row-gap: ${getCssSizeValue(32)};
		padding: ${getCssSizeValue(40)} ${getCssSizeValue(32)};
		border-right: ${({ $borderRight }) => ($borderRight ? "solid 1px black" : "none")};
	}
`

const IconButton = styled(SimpleIconButton)`
	position: absolute;
	border-left: solid 1px black !important;
	border-bottom: solid 1px black !important;
	border-top: none !important;
	border-right: none !important;
	top: 0;
	right: 0;
`

export const Skeleton = ({ borderRight, ...props }) => {
	return <Wrapper $borderRight={borderRight} className={`col-desktop-3 loading`} {...props} />
}

const Info = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: ${getCssSizeValue(4)};

	.text:not(.square.static) {
		padding-left: ${getCssSizeValue(16)};
	}

	.text.email {
		word-break: break-all;
	}
`
const Unit = ({ data = {}, borderRight = true }) => {
	const name = data?.name || ""
	const postalCode = data?.postalCode || ""
	const city = data?.city || ""
	const street = data?.street || ""
	const phone = data?.phone || ""
	const email = data?.email || ""
	const unitAddressText = useGlobals("unitAddressText")
	const unitContactText = useGlobals("unitContactText")
	const { currentUnit, setCurrentUnit, setView } = useNavigatorContext()
	const handleOnClick = useCallback(() => {
		setCurrentUnit((prevState) => {
			const isCurrent = prevState.id === data.id
			if (!isCurrent) setView(NAVIGATOR_VIEW_TYPE.PIN_MAP)
			return isCurrent ? {} : data
		})
	}, [setView, setCurrentUnit, data])

	return (
		<Wrapper
			onClick={handleOnClick}
			$borderRight={borderRight}
			className={`col-mobile-8 col-desktop-3 ${currentUnit?.id === data.id ? "active" : ""}`}
		>
			<IconButton name={ICONS.PIN_MAP} color="richBlack" />
			<Text className="typo-borna-127 name">{name}</Text>
			<Info>
				<Text className="typo-strawford typo-strawford-94 square static">{unitAddressText}:</Text>
				<Text className="typo-strawford typo-strawford-50">
					{postalCode} {city}
				</Text>
				<Text className="typo-strawford typo-strawford-50">{street}</Text>
			</Info>
			{(email.length > 0 || phone.length > 0) && (
				<Info>
					<Text className="typo-strawford typo-strawford-86 square static">{unitContactText}:</Text>
					{email.length > 0 && <Text className="typo-strawford typo-strawford-50 email">{email}</Text>}
					{phone.length > 0 && <Text className="typo-strawford typo-strawford-50 phone">{phone}</Text>}
				</Info>
			)}
		</Wrapper>
	)
}

export default Unit
